export default "__VITE_ASSET__DwacsSyQ__"